const PENDING_PASSWORD_RESET = 'pendingPasswordReset';
const PENDING_PASSWORD_RESET_MAX_AGE_MS = 5 * 60 * 1000;

export function setPendingPasswordReset(): void {
  localStorage.setItem(PENDING_PASSWORD_RESET, Date.now().toString());
}

/** Reads and clears: an abandoned logout must not send the next visitor off to the IdP. */
export function consumePendingPasswordReset(): boolean {
  const stored = localStorage.getItem(PENDING_PASSWORD_RESET);
  localStorage.removeItem(PENDING_PASSWORD_RESET);
  const createdAt = Number(stored);
  return !!stored && Number.isFinite(createdAt) && Date.now() - createdAt <= PENDING_PASSWORD_RESET_MAX_AGE_MS;
}

export function clearPendingPasswordReset(): void {
  localStorage.removeItem(PENDING_PASSWORD_RESET);
}

export function buildPasswordResetUrl(issuerUrl: string, clientId: string): string {
  const url = new URL(`${issuerUrl.replace(/\/+$/, '')}/login-actions/reset-credentials`);
  url.searchParams.set('client_id', clientId);
  return url.toString();
}
